// extracted by mini-css-extract-plugin
export var backgroundNeutral05 = "BrochurePageBox-module--background-neutral05--0f2d2";
export var backgroundNeutral10 = "BrochurePageBox-module--background-neutral10--51edd";
export var backgroundTitanium = "BrochurePageBox-module--background-titanium--2dbe4";
export var backgroundWhite = "BrochurePageBox-module--background-white--2d702";
export var content = "BrochurePageBox-module--content--cf4c5";
export var footer = "BrochurePageBox-module--footer--ad0c2";
export var imgContainer = "BrochurePageBox-module--img-container--f0f46";
export var imgContainerWrapper = "BrochurePageBox-module--img-container-wrapper--ec37e";
export var paragraph = "BrochurePageBox-module--paragraph--ab360";
export var section = "BrochurePageBox-module--section--5a7ca";
export var subtitle = "BrochurePageBox-module--subtitle--8af9a";
export var title = "BrochurePageBox-module--title--86b5e";